<template>
  <div>
    <nav-bar
      :title="label"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
      :placeholder="true"
    />
    <!-- <div class="abc" @click="show = true">{{fieldValue?fieldValue:'请选择分类'}}</div> -->
    <!-- <van-popup v-model="show" style="margin-top:45px" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择分类"
        :options="options"
        @close="show = false"
        @finish="onFinish"
      />
    </van-popup> -->
    <img :src="bacImg" class="img" alt fit="cover" />
    <div style="margin: 0.8rem">
      <div @click="showPopup">
        <div style="display: inline-block">
          <van-icon
            style="line-height: 20px; vertical-align: middle"
            name="descending"
          />{{
            filterYears ? `${filterYears}年${filterMonth}月之前` : "按时间筛选"
          }}
        </div>
        <span style="float: right">总计:{{ total }}条</span>
      </div>
      <van-popup
        v-model="timeFilterTrigger"
        get-container="body"
        position="bottom"
        :safe-area-inset-bottom="true"
        :style="{ width: '100%' }"
      >
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择年月"
          :formatter="formatter"
          @confirm="filterNewsList"
          @cancel="timeFilterTrigger = false"
      /></van-popup>
    </div>

    <cell
      :title="v.topic"
      v-for="(v, i) in list"
      :key="i"
      :label="v.postDate"
      @click="toDetail(v)"
    >
      <template #label>
        <div style="font-size:12px">发布时间：{{ v.postDate }}</div>
        <div style="font-size:12px">信息来源：{{ v.briefIntroduction }}</div>
      </template>
    </cell>
    <my-btn :value="showPage ? '加载更多' : '没有更多'" @click="evenMore" />
  </div>
</template>

<script>
//详情列表
import homeCall from "../../common/homeCall";
import { NavBar, Cell } from "vant";
import service from "../../api/service";
import myBtn from "../../common/myBtn";

export default {
  name: "detailList",
  components: {
    homeCall,
    NavBar,
    Cell,
    myBtn,
  },
  data() {
    return {
      baseURLB: service.baseURLB,
      label: "",
      bacImg: "",
      id: "",
      list: [],
      pageIndex: 1,
      showPage: true,
      show: false,
      fieldValue: "",
      cascaderValue: "",
      xwSectionIds: "",
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [],
      currentDate: new Date(),
      timeFilterTrigger: false,
      total: 0,
      filterYears: null,
      filterMonth: null,
    };
  },
  mounted() {
    // let q = this.$store.state.detailList;
    let q = this.$route.query;
    this.label = q.label;
    this.bacImg = q.bacImg;
    this.id = q.id;
    this.ininType();
    this.init();
  },
  methods: {
    showPopup() {
      this.timeFilterTrigger = true;
      console.warn(this.timeFilterTrigger);
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    filterNewsList(e) {
      console.warn(e.getFullYear(), e.getMonth());
      this.filterYears = e.getFullYear();
      this.filterMonth = e.getMonth() + 1;

      this.timeFilterTrigger = false;

      this.list = [];
      this.pageIndex = 1;
      this.showPage = true;

      this.init();
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      let str = "";
      selectedOptions.map((option) => {
        str = option.text;
      });
      this.xwSectionIds = selectedOptions
        .map((option) => option.value)
        .join(",");
      this.fieldValue = str;
      this.list = [];
      this.init();
    },
    //初始化分类
    ininType() {
      function digui(list) {
        let res = [];
        res = list.map((item) => {
          let children = [];
          if (item.children && item.children.length) {
            children = digui(item.children);
          }

          return {
            ...item,
            text: item.title,
            value: item.id,
            children: children && children.length ? children : null,
          };
        });
        return res;
      }
      service.get("/api/xw/getAppTree").then((res) => {
        if (res.status === 200) {
          let defaultOption = { text: "全部分类", value: "" };
          let array = digui(res.data);
          this.options = [defaultOption, ...array];
        }
      });
    },
    onClickLeft() {
      this.$router.push({ path: "/home" });
    },
    toDetail(row) {
      sessionStorage.setItem("row", JSON.stringify(row));
      this.$router.push({
        path: "/xwDetail",
        query: { sourcePath: "/detailList", contentId: row.contentid },
      });
    },
    init() {
      let params = {
        id: this.id,
        page: this.pageIndex,
        xwSectionIds: this.xwSectionIds,
        size: 10,
        year: this.filterYears,
        month: this.filterMonth,
      };

      if (!params.year) delete params.years;
      if (!params.month) delete params.month;

      service
        .get("/api/xw/getNewsListByColumnID", {
          id: this.id,
          page: this.pageIndex,
          xwSectionIds: this.xwSectionIds,
          size: 10,
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.length === 0) {
              this.showPage = false;
            }
            this.list = this.list.concat(res.data);
            this.total = res.total;
          }
        });
    },
    //更多
    evenMore() {
      this.pageIndex += 1;
      this.init();
    },
  },
};
</script>

<style scoped>
.abc {
  position: fixed;
  height: 45px;
  width: 30%;
  text-align: right;
  line-height: 45px;
  top: 0px;
  right: 0px;
  z-index: 99;
  padding-right: 15px;
}
.box {
  margin: 1rem;
}

.img {
  width: 100%;
  height: 150px;
}

.title {
  color: #ffffff;
  position: absolute;
  top: 8rem;
  width: 100%;
  text-align: center;
}
</style>